import React, { useState, useRef, useEffect } from 'react'
import gsap from 'gsap'
import PropTypes from 'prop-types'

// Hooks
import { useScrolledAnimation } from '../../animation/useScrolledAnimation'

// Vars
import { Label } from '../../../styles/vars/textStyles.style'

// Styles
import {
  FormSelectLabel,
  FormSelectName,
  FormSelectElement,
  FormSelectLine,
} from './index.style'

const FormSelect = ({
  name,
  id,
  options,
  required,
  forwardRef,
  formFields,
  setFormFields,
}) => {
  const [focused, setFocused] = useState(false)

  /**
   * If input fields have a value in them, move the label to be higher
   */
  const updateLabelPos = e => {
    if (e.target.value.length > 0) {
      setFocused(true)
    } else {
      setFocused(false)
    }
  }

  const updateInputValue = e => {
    if (id === 'country') {
      setFormFields({
        ...formFields,
        country: e.target.value,
        selectedSignUpCountry: e.target.value,
      })
    } else return
  }

  const updateFunction = e => {
    updateLabelPos(e)
    updateInputValue(e)
  }

  const labelRef = useRef(),
    lineRef = useRef(),
    selectIn = useRef()

  useScrolledAnimation({
    id: `form-field-${id}`,
    transition: selectIn,
  })

  useEffect(() => {
    if (!labelRef.current || !lineRef.current) return

    selectIn.current = gsap.timeline({
      paused: true,
      defaults: {
        duration: 2,
        ease: 'power1.out',
      },
    })

    selectIn.current.fromTo(
      labelRef.current,
      {
        opacity: 0,
      },
      {
        opacity: 0.4,
      },
      0
    )

    selectIn.current.fromTo(
      lineRef.current,
      {
        scaleX: 0,
      },
      {
        scaleX: 1,
      },
      0
    )
  }, [labelRef, lineRef])

  return (
    <FormSelectLabel
      htmlFor={id}
      ref={forwardRef}
      data-scroll
      data-scroll-id={`form-field-${id}`}
    >
      <FormSelectElement
        name={name}
        id={id}
        type={'select'}
        required={required}
        defaultValue={''}
        onChange={updateFunction}
      >
        {options &&
          React.Children.toArray(
            options.map((item, itemIndex) => {
              return (
                <option disabled={itemIndex === 0} value={item.value}>
                  {item.label}
                </option>
              )
            })
          )}
      </FormSelectElement>
      <FormSelectName focused={focused} ref={labelRef}>
        <Label>{name}</Label>
      </FormSelectName>
      <FormSelectLine ref={lineRef} />
    </FormSelectLabel>
  )
}

FormSelect.propTypes = {
  inView: PropTypes.bool,
  name: PropTypes.string,
  id: PropTypes.string,
  options: PropTypes.array,
  required: PropTypes.bool,
  forwardRef: PropTypes.object,
  delay: PropTypes.number,
}

export default FormSelect
